'use strict';
import angular from 'angular';
import './widget.gaugechart.ctrls';
import './widget.gaugechart.directives';
import './widget.gaugechart.services';

angular.module('widget.gaugechart', [
    'widget.gaugechart.ctrls',
    'widget.gaugechart.directives',
    'widget.gaugechart.services',
]);